import React, { useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { Box, Drawer, IconButton, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material"
import { FormattedMessage } from 'react-intl';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import dashboard from '../../assets/dashboard.png'
import setting from '../../assets/settings.png'
import '../../css/global.css'

const Sidebar = ({
    drawerWidth,
    isSidebarOpen,
    setIsSidebarOpen,
    isNonMobile,
}) => {

    const sidebarRef = useRef(null);
    const { pathname } = useLocation()
    const [active, setActive] = useState("")

    const navigate = useNavigate()

    useEffect(() => {
        setActive(pathname.substring(1))
    }, [pathname]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!isNonMobile && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsSidebarOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [isNonMobile, setIsSidebarOpen]);

    useEffect(() => {
        if (isNonMobile) {
            setIsSidebarOpen(true);
        }
    }, [isNonMobile, setIsSidebarOpen]);

    const handleOpenClose = () => {
        if (!isNonMobile) {
            setIsSidebarOpen(false)
        }
    }


    const navItems = [
        {
            text: "Dashboard",
            translationKey: "dashboardNav",
            image: <img src={dashboard} alt="dashboard" width="25" height="25" />
        },       
        {
            text: "All Angpao",
            translationKey: "angpaoNav",
            image: <img src={setting} alt="angpao" width="25" height="25" />

        }
    ]

    const DrawerContent = () => {
        return (
            <Box>
                {/* Nav Item */}
                <List>
                    {navItems.map(({ text, image, translationKey, onClick }) => {
                        if (!image) {
                            return (
                                <Typography key={text}>
                                    {text}
                                </Typography>
                            )
                        }

                        const lcText = text.toLowerCase().replace(/[()\s]+/g, '');

                        return (
                            <ListItem key={text} disablePadding>
                                <ListItemButton
                                    onClick={() => {
                                        navigate(`/${lcText}`);
                                        setActive(lcText)
                                    }}
                                    sx={{
                                        fontSize: '13px',
                                        backgroundColor: active === lcText ? "#ffffff" : "transparent",
                                        color: active === lcText ? '#102D67CC' : "#ffffff",
                                        borderRadius: active === lcText ? '0.55rem' : 'none',
                                        margin: "0.3rem 1rem",
                                        '&:hover': {
                                            backgroundColor: active === lcText ? "#ffffff" : "none",
                                        }
                                    }}
                                >
                                    {image}
                                    <ListItemText primary={<FormattedMessage id={translationKey} />} sx={{ marginLeft: '1rem' }} />
                                </ListItemButton>
                            </ListItem>
                        )
                    })}
                </List>
            </Box>
        )
    }

    return (
        <Box component="nav">
            {isSidebarOpen && (
                <Drawer
                    open={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                    onClick={handleOpenClose}
                    variant="permanent"
                    anchor='left'
                    ref={sidebarRef}
                    sx={{
                        width: drawerWidth,
                        "& .MuiDrawer-paper": {
                            // color: theme.palette.secondary[200],
                            backgroundColor: "#001325F2",
                            boxSizing: "border-box",
                            borderWidth: isNonMobile ? 0 : "2px",
                            width: drawerWidth,
                            flexShrink: 0,
                        },
                        "& .MuiTypography-root": {
                            fontSize: '13px'
                        }
                    }}
                >
                    <Box width="100%">
                        <Box m="1.5rem 2rem 1rem 2rem" >
                            <Box color="#4385EA">

                                {!isNonMobile && (
                                    <Box className='flexBetween'>
                                        <Typography>
                                            {/* <img src={Logo} alt="Logo" style={{ width: "30px", height: "25px" }} onClick={() => { navigate(`/dashboard`) }} /> */}
                                        </Typography>

                                        <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                                            <ChevronLeftOutlinedIcon style={{ color: 'white' }} />
                                        </IconButton>
                                    </Box>
                                )}

                                {isNonMobile && (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'end'
                                        }}
                                    >
                                        <Typography>
                                            {/* <img src={Logo} alt="Logo" style={{ width: "30px", height: "25px" }} onClick={() => { navigate(`/dashboard`) }} /> */}
                                        </Typography>

                                        <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                                            <ChevronLeftOutlinedIcon style={{ color: 'white' }} />
                                        </IconButton>
                                    </Box>
                                )}
                            </Box>
                        </Box>

                        <DrawerContent />

                    </Box>
                </Drawer>
            )}
        </Box>
    )
}

export default Sidebar